import { useEffect, useState } from 'react';
import { motion, useScroll } from 'framer-motion';

const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'About', href: '#about' },
  { name: 'Services', href: '#services' },
  { name: 'Process', href: '#process' },
  { name: 'Testimonials', href: '#testimonials' },
  { name: 'Contact', href: '#contact' },
];

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { scrollY } = useScroll();

  useEffect(() => {
    const unsubscribe = scrollY.on('change', (latest) => {
      setIsScrolled(latest > 100);
    });

    return () => unsubscribe();
  }, [scrollY]);

  return (
    <motion.nav
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.6, 0.05, 0.01, 0.9] }}
      className={`sticky top-0 left-0 right-0 z-40 transition-all duration-300 border-b ${
        isScrolled
          ? 'bg-white shadow-lg border-b border-blue-100'
          : 'bg-white border-transparent'
      }`}
    >
      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-18 lg:h-18">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 select-none">
            <span className="flex items-end gap-2">
              <span className="text-2xl lg:text-3xl font-bold text-primary-navy tracking-tight uppercase">
                ZORAXO
              </span>
              <span className="text-xs text-primary-navy tracking-tight pb-1">
                Technologies Pvt Ltd
              </span>
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-10">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="relative text-sm font-medium text-neutral-dark-grey hover:text-primary-navy transition-colors duration-300 group"
              >
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent-blue transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <a href="#contact">
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              className="hidden lg:block px-6 py-3 bg-accent-blue text-white font-semibold rounded-lg shadow-glow-blue hover:bg-accent-electric transition-all duration-300"
            >
              Get in Touch
            </motion.button>
          </a>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2">
            <div className="w-6 h-5 flex flex-col justify-between">
              <span className="w-full h-0.5 bg-primary-navy transition-all" />
              <span className="w-full h-0.5 bg-primary-navy transition-all" />
              <span className="w-full h-0.5 bg-primary-navy transition-all" />
            </div>
          </button>
        </div>
      </div>
    </motion.nav>
  );
}
